import React, { Fragment, memo } from 'react'

import { Icon, ThumbUp, Tooltip, User } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string } from 'prop-types'

import { handleTooltipTriggerClick } from 'Pods/SearchPage/Shared/QualityContent/constants'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

const RATING_ICON_SIZE = { width: '10', height: '10' }

// The stats line under a designer's name: models, rating and the following glyph, 4px dots
// between them (Figma 3183:39993).
function Meta({ tooltipId, modelCount = null, ratingPercent = null, following = false }) {
  const translate = useTranslate()

  const items = []

  if (modelCount !== null) {
    items.push(
      <span key="models" className="designer-content__models cgt-caption">
        {translate('search_page.filters.designers.models_count', { count: modelCount })}
      </span>
    )
  }

  if (ratingPercent !== null) {
    items.push(
      <span key="rating" className="designer-content__rating cgt-caption-semibold">
        <Icon
          notSpaced
          svgComponent={ThumbUp}
          size={RATING_ICON_SIZE}
          color="dark"
          className="designer-content__rating-icon"
        />
        {`${ratingPercent}%`}
      </span>
    )
  }

  // Figma has a user-check glyph; Triangle ships none, so User stands in.
  if (following) {
    items.push(
      <Tooltip
        key="following"
        id={tooltipId}
        content={translate('search_page.filters.designers.following_tooltip')}
        place="top"
      >
        <span className="designer-content__following" onClick={handleTooltipTriggerClick}>
          <Icon
            notSpaced
            svgComponent={User}
            size="tiny"
            color="dark"
            className="designer-content__following-icon"
            role="img"
            aria-label={translate('search_page.filters.designers.following_indicator')}
          />
        </span>
      </Tooltip>
    )
  }

  if (items.length === 0) return null

  return (
    <span className="designer-content__meta">
      {items.map((item, index) => (
        <Fragment key={item.key}>
          {index > 0 && <span className="designer-content__meta-dot" aria-hidden="true" />}
          {item}
        </Fragment>
      ))}
    </span>
  )
}

Meta.propTypes = {
  tooltipId: string.isRequired,
  modelCount: number,
  ratingPercent: number,
  following: bool,
}

export default memo(Meta)
